import { DeleteOutlined } from '@ant-design/icons'
import { Button, Modal } from 'antd'
import { TFunction } from 'i18next'

import { Permission } from '../../../../entities/permissions/types/permission.types'
import { Role } from '../types/roles-page-types'

export const getRoleTableColumns = (
  t: TFunction,
  handleRoleChoose: (role: Role) => void,
  handleDeleteRole: (roleId: number) => void,
  apiPermissions: Permission[],
) => {
  return [
    {
      title: t('common.name'),
      dataIndex: 'name',
      key: 'name',
      render: (text: string, record: Role) => (
        <span
          onClick={() => {
            handleRoleChoose(record)
          }}
          style={{ cursor: 'pointer', color: '#1890ff' }}
        >
          {text}
        </span>
      ),
    },
    {
      title: t('common.permissions'),
      dataIndex: 'permissions',
      key: 'permissions',
      render: (_: unknown, record: Role) => (
        <span>
          {Object.keys(record.permissions).length} / {apiPermissions.length}
        </span>
      ),
    },
    {
      title: t('common.actions'),
      dataIndex: 'actions',
      key: 'actions',
      width: 100,
      render: (_: unknown, record: { id: number; name: string }) => (
        <Button
          color="danger"
          onClick={() => {
            Modal.confirm({
              title: t('objectsPage.deleteConfirmTitle'),
              content: `${record.name} ${t('objectsPage.deleteDescription')}`,
              onOk: () => handleDeleteRole(record.id),
            })
          }}
          variant="text"
        >
          <DeleteOutlined />
        </Button>
      ),
    },
  ]
}
